import {useMutation} from "@tanstack/react-query";

import {deleteMaterialFunctionMutationOptions} from "./delete-material-function.mutation-options";

export function useDeleteMaterialFunction() {
  return useMutation(deleteMaterialFunctionMutationOptions());
}
